var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleStore.moduleId)?_c('ModuleBuilder',{staticClass:"h-full"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }